<template>
    <Sidebar />
    <Content class="analytics-content analytics-big-box">
        <div class="inner inner-box">
            <div style="height:100%">
                <AnalyticsHeader v-if="$store.state.user_data && $store.state.user_data.merchant_account_id" :key="any_head_key"/>    
                <div class="main collection-main">
                    
                    <CollectionList v-if="$store.state.user_data.merchant_account_id && can_start" :date_range="{ start_date:start_date, end_date:end_date }" :key="coll_key" :the_type="'post'" :selected_creator_tags="selected_creator_tags" :creator_tag_operation_type="creator_tag_operation_type"/>
                    
                </div>
            </div>
        </div>
    </Content>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import AnalyticsHeader from '@/components/analytics/AnalyticsHeader.vue';
import CollectionList from '@/components/creator/CollectionList.vue';
import Content from '@/components/ui/Content.vue';
import moment from 'moment';
import { handleMaxMinFun } from '@/utils/SwitchFun.js';

export default {
    name: 'Analytics - Products',

    data() {
        return {
            start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
            end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
            coll_key: 0,
            can_start:false,//阻止有些元件在時間整理完之前出現
            selected_creator_tags: [],
            creator_tag_operation_type: 'or',
        }
    },

    watch: {
        '$store.state.user_data.merchant_account_id': function (val) {
            this.startFunction();
        },
    },
    computed: {
    },

    components: {
        Sidebar,
        Scrollbar,
        AnalyticsHeader,
        CollectionList,
        Content,
    },

    methods:{
        startFunction(){
            // Initialize dates from store if available
            if (this.$store.state.save_analytics_start_date && this.$store.state.save_analytics_end_date) {
                this.start_date = this.$store.state.save_analytics_start_date;
                this.end_date = this.$store.state.save_analytics_end_date;
            }

            let checkTime = handleMaxMinFun( this.start_date, this.end_date ,this);
            this.start_date = checkTime[0];
            this.end_date= checkTime[1];
            this.can_start=true;
        },
    },

    mounted(){
        if(!this.$store.state.user_data.permission_list.analytics.viewPerformanceSummaries.permission){
            this.$router.push('/creator/list');
            return;
        }
        this.startFunction();

        // Initialize creator tags from store if available (following same pattern as AnalyticsHeader)
        if (this.$store.state.save_selected_tags && this.$store.state.save_selected_tags.length > 0) {
            this.selected_creator_tags = this.$store.state.save_selected_tags;
            this.creator_tag_operation_type = this.$store.state.save_tag_operation_type || 'or';
        }

        this.EventBus.off('update-date');
        this.EventBus.on('update-date', (obj) => {
            this.start_date = obj.start_date;
            this.end_date = obj.end_date;
            this.current_page=1;

            setTimeout(() => {
                this.coll_key+=1;
            }, 10);
        });

        // Listen for creator tag updates
        this.EventBus.off('analytics-tags-updated');
        this.EventBus.on('analytics-tags-updated', (data) => {
            console.log('!analytics-tags-updated!', data);
            this.selected_creator_tags = data.tags;
            this.creator_tag_operation_type = data.operation_type;
            // Force CollectionList to refresh
            setTimeout(() => {
                this.coll_key+=1;
            }, 10);
        });
    },

    beforeUnmount() {
        // Clean up event listeners
        this.EventBus.off('update-date');
        this.EventBus.off('analytics-tags-updated');
    }

}
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.analytics-content {

    .inner {
        height: 100%;
        padding: 24px 48px; //24px 24px 0 24px;

        .collection-main{
            height: calc(100% - 126px) !important;
        }

    }

    .collections .inner{
        padding: unset;

        .title-content  {
            max-width:unset !important;
        }
    }

    .data-list{
        max-height: calc(95vh - 200px);
        thead{
            position: sticky;
            top: 0;
            z-index: 10;
            background: var(--white);
        }
    }
}
</style>